import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-muted autoscaler"
}

import PopoverCard from '@shell/components/PopoverCard.vue';
import { computed } from 'vue';
import RcButton from '@components/RcButton/RcButton.vue';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import AutoscalerCard from '@shell/components/AutoscalerCard.vue';

export interface Props {
  value: string | boolean;
  row: any;
}

export interface Detail {
  label: string;
  value?: string | { component: any; props: any };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Autoscaler',
  props: {
    value: { type: [String, Boolean], default: true },
    row: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const i18n = useI18n(store);

const checked = computed(() => props.value === true || props.value === 'true');
const actionIcon = computed(() => props.row.provCluster.isAutoscalerPaused ? 'icon-play' : 'icon-pause');
const actionText = computed(() => props.row.provCluster.isAutoscalerPaused ? i18n.t('autoscaler.card.resume') : i18n.t('autoscaler.card.pause'));
const stopPropagation = (event: Event) => {
  // This is to prevent click events from getting to the table row which ends up selecting the row
  event.stopPropagation();
};

return (_ctx: any,_cache: any) => {
  return (checked.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "autoscaler",
        onClick: stopPropagation
      }, [
        _createVNode(PopoverCard, {
          "card-title": _unref(i18n).t('autoscaler.card.title'),
          "fallback-focus": ".autoscaler .action"
        }, _createSlots({
          "card-body": _withCtx(() => [
            _createVNode(AutoscalerCard, {
              value: props.row.provCluster
            }, null, 8, ["value"])
          ]),
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon icon-checkmark" }, null, -1)),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _cache[2] || (_cache[2] = _createTextVNode())
          ]),
          _: 2
        }, [
          (props.row.canExplore)
            ? {
                name: "heading-action",
                fn: _withCtx(({close}) => [
                  (__props.row.provCluster.canPauseResumeAutoscaler)
                    ? (_openBlock(), _createBlock(RcButton, {
                        key: 0,
                        variant: "secondary",
                        size: "small",
                        class: "action",
                        onClick: () => {props.row.toggleAutoscalerRunner(); close()}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass(`icon ${actionIcon.value} icon-sm`)
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(actionText.value), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["card-title"])
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_1, "\n    —\n  "))
}
}

})